<template>
    <div class="mx-auto">
        <div class="loader" v-if="loading"></div>
        <div v-else>
            <page-title :title="$t('registers.mentors.title')" :showTitle="false"></page-title>

            <div class="btn-group" role="group" aria-label="Basic example">
                <button type="button"
                        class="btn btn-primary"
                        @click="backToRegister">
                    <i class="fas fa-th-list"></i> {{ $t('backToList') }}
                </button>
            </div>
            <div class="card mt-3">
                <div class="card-header bg-primary text-white">
                    <div class="card-title h5 m-0">{{ $t('personalData') }}</div>
                </div>
                <div class="card-body">
                    <person-details
                        :show-extended="true"
                        :person="mentor.person"></person-details>
                    <div class="row">

                        <div class="form-group col-md-12 col-lg-6 col-xl-4">
                            <label class="font-weight-bold" :for="'directorate' + _uid">{{
                                $t('registers.mentors.gridHeaders.directorate') }}</label>
                            <input type="text" class="form-control" v-model="mentor.directorate" readonly>
                        </div>
                        <div class="form-group col-md-12 col-lg-6 col-xl-4">
                            <label class="font-weight-bold" :for="'title' + _uid">{{
                                $t('registers.mentors.gridHeaders.id')
                                }}</label>
                            <input type="text" class="form-control" :id="'id' + _uid"
                                   v-model="mentor.id" readonly>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card mt-3">
                <div class="card-header bg-primary text-white">
                    <div class="card-title h5 m-0">{{ $t('registers.mentors.gridHeaders.reasonForJoiningLikeMentor') }}
                    </div>
                </div>
                <div class="card-body row">
                    <div class="form-group col-lg-12">
                        <label class="font-weight-bold" :for="'managementBoardDecision' + _uid">{{
                            $t('registers.mentors.gridHeaders.decision') }}</label>
                        <input type="text" class="form-control" :id="'managementBoardDecision' + _uid"
                               v-model="mentor.decisionForJoiningMentor" readonly>
                    </div>
                    <div class="form-group col-md-12 col-lg-6 col-xl-4">
                        <label class="font-weight-bold" :for="'title' + _uid">{{
                            $t('registers.mentors.gridHeaders.startDate')}}</label>
                        <datepicker v-model="mentor.startDateMentoring"></datepicker>
                    </div>
                    <div class="form-group col-md-12 col-lg-6 col-xl-4">
                        <label class="font-weight-bold" :for="'title' + _uid">{{
                            $t('registers.mentors.gridHeaders.endDate')}}</label>
                        <datepicker v-model="mentor.endDateMentoring"></datepicker>
                    </div>
                    <div class="form-group col-12">
                        <label class="font-weight-bold" :for="'additionalInfo' + _uid">{{
                            $t('registers.mentors.gridHeaders.additionalInfo') }}</label>
                        <input type="text" class="form-control" :id="'additionalInfo' + _uid"
                               v-model="mentor.additionalInfoMentoring" readonly>
                    </div>
                </div>
            </div>
            <div class="card mt-3">
                <div class="card-header bg-primary text-white">
                    <div class="card-title h5 m-0">{{ $t('registers.participants.title') }}</div>
                </div>
                <div class="card-body">
                    <div v-for="(participant,index) in mentor.participantsDetails" :key="index">
                        <label class="font-weight-bold" :for="'title' + _uid">{{
                            $t('registers.participants.gridHeaders.participant')}}</label>
                        <person-details :person="participant"></person-details>
                        <hr>
                    </div>
                </div>
            </div>
            <div class="mt-3" v-if="mentor">
                <AuxiliaryRegisterDetails :entryId="mentor.auxRegisterEntityId"></AuxiliaryRegisterDetails>
            </div>
        </div>
    </div>
</template>

<script>
    import { MentorDetails, InstitutionDetails } from '../../../models/models'
    import DatePicker from '../../../components/datepicker/DatePickerDetails';
    import PersonDetails from "../../../components/person/PersonDetails";
    import PageTitle from '../../../components/common/PageTitle';
    import AuxiliaryRegisterDetails from '../../../components/dynamic/AuxiliaryRegisterDetails'

    export default {
        components: {
            'datepicker': DatePicker,
            'person-details': PersonDetails,
            PageTitle,
            AuxiliaryRegisterDetails
        },
        data() {
            return {
                id: '',
                mentor: new MentorDetails(),
                institution: new InstitutionDetails(),
                loading: false,
            }
        },
        methods: {
            backToRegister() {
                this.$router.push('/registers/mentor');
            },
            loadData() {
                this.loading = true;
                this.$http.get(`/api/mentor/GetDetails/${this.id}`).then(result => {
                    this.mentor = new MentorDetails(result.data);
                }).catch(error => {
                    // TODO:
                }).then(() => { this.loading = false; });
            }
        },
        watch: {
            'mentor.institutionId'(newVal, oldVal) {
                if (this.mentor.institutionId !== undefined
                    && this.mentor.institutionId !== '' &&
                    this.mentor.institutionId != null) {
                    this.$http.get(`/api/Institution/GetDetails/${this.mentor.institutionId}`).then(result => {
                        this.institution = new InstitutionDetails(result.data);
                    });
                }
            }
        },
        mounted() {
            this.id = this.$route.params.id;
            if (this.id) {
                this.loadData();
            }
        }
    }
</script>

<style scoped>
    input[readonly] {
        background-color: whitesmoke;
    }

    textarea[readonly] {
        background-color: whitesmoke;
    }
</style>
